export default __webpack_public_path__ + "static/webRotator/svg/07ffd8c18606d7e8383dd58d2eccbb05.svg";